


import { Component, ElementRef, HostListener, inject, Input, viewChild, ViewContainerRef } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { tankCardDataType } from '../../models/atg-dashboard';
import { Tooltip } from '../tooltip/tooltip.component';

@Component({
  selector: 'app-tank-card',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './tank-card.component.html',
  styleUrl: './tank-card.component.scss'
})
export class TankCard {
  private readonly document = inject(DOCUMENT);

  private tankCardEle = viewChild<ElementRef>('tankCard');
  @Input() tankInfo:tankCardDataType;
  @Input() tankNo: number;
  private popup: HTMLDivElement | null = null;
  private componentRef: any;

  private container = inject(ViewContainerRef);
  showTooltip(isClicked: boolean = false) {
    const windowRect = this.document.documentElement.getBoundingClientRect();
    if (!this.tankInfo) return;
    if(windowRect.width > 767 && isClicked) return;

    if (this.popup) {
      this.removeTooltip();
    }

    const element = this.tankCardEle()?.nativeElement as HTMLElement;
    if (element) {
      const elementRect = element.getBoundingClientRect();

      const componentRef = this.container.createComponent(Tooltip);
      componentRef.instance.tooltipType = 'tank-card';
      componentRef.instance.tooltipData = this.tankInfo;
      componentRef.location.nativeElement.style.display = 'block';

      const popup = this.document.createElement('div');
      popup.classList.add('popup-container');
      popup.style.zIndex = '9999';
      popup.style.position = 'fixed';

      popup.appendChild(componentRef.location.nativeElement);
      this.document.body.appendChild(popup);

      setTimeout(() => {
        const popupRect = popup.getBoundingClientRect();
        if (windowRect.width > 767) {
          popup.style.top = elementRect.top + 'px';
          popup.style.left = elementRect.right + 'px';
        } else {
          const popupHeight = popupRect.height || 253;
          if (windowRect.bottom - elementRect.bottom >= popupHeight) {
            popup.style.top = elementRect.bottom + 'px';
          } else {
            popup.style.top = elementRect.top - (popupHeight - 16) + 'px'; // 16 is margin
          }
          popup.style.left = 15 + 'px';
          componentRef.location.nativeElement.style.width = windowRect.width - 35 + 'px';
        }
      }, 1);

      this.popup = popup;
      this.componentRef = componentRef;
    }
  }

  // Remove tooltip on mouseleave or click outside or other logic
  removeTooltip() {
    if (this.popup && this.popup.parentNode) {
      this.popup.parentNode.removeChild(this.popup);
    }
    this.componentRef && this.componentRef.destroy(); // This will remove it from Angular and trigger ngOnDestroy
  };

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    const tankCardEle = this.tankCardEle()?.nativeElement;
    if (!tankCardEle) return;
    const element = event.target as HTMLElement;
    const overlay = this.document.querySelector('.tooltip-overlay');
    const isOverPopup = this.popup?.contains(element);
    const isOverTankCard = tankCardEle.contains(element);
    const isOverOverlay = overlay?.contains(element);
    if (element && this.popup && overlay && ((!isOverPopup && !isOverTankCard) || (isOverOverlay))) {
      this.removeTooltip();
    }
  }
  @HostListener('document:touchstart', ['$event']) onTouchStart($event:Event) {this.removeTooltip()}
}
